<!--
 * @Author: yyl
 * @Date: 2025-06-26 08:55:40
 * @LastEditTime: 2025-07-01 15:58:12
 * @LastEditors: yyl
 * @Description: 
 * @FilePath: /bolimao/Users/bolimao/Desktop/A-类私有云的项目/下关中学/xiaguan-schools-website/src/components/home/CardList.vue
 * 可以输入预定的版权声明、个性签名、空行等
-->
<template>
  <div class="card">
    <div style="margin: 0 6px">
      <div
        style="border-bottom: 1px dashed #ccc"
        v-for="item in listData"
        :key="item.id"
        @click="handleGoDetailClick(item)"
      >
        <div class="card-content" style="padding: 8px 0 6px; font-size: 14px">
          {{ item.title }}
        </div>
        <div class="card-subtitle" style="padding-bottom: 4px">
          {{ item.created_at }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    sectionId: {
      type: [Number, String],
      default: 0,
    },
    title: {
      type: String,
      default: "",
    },

    listData: {
      type: Array,
    },
  },

  data() {
    return {}
  },

  // watch: {
  //   params: {
  //     deep: true,
  //     immediate: true, // （可选）立即触发一次
  //     handler() {
  //       this.getData()
  //     },
  //   },
  // },

  mounted() {},

  methods: {
    // getData() {
    //   const articles = this.params.articles || []

    //   this.oneData = articles[0] || {}
    //   this.listData = articles.filter((item) => item.id != this.oneData.id)
    // },

    handleGoListClick() {
      this.$router.push(`/list?section_id=${this.sectionId}`)
    },

    handleGoDetailClick(item) {
      this.$router.push(`/article?id=${item.id}`)
    },
  },
}
</script>

<style lang="scss" scoped>
// .card {
//   height: 470px;
//   color: #565656;
//   font-size: 16px;
// }

// .card-title {
//   padding: 0 4px;
//   border-bottom: 3px solid #b4d13d;
// }

// .card-title--left {
//   color: #42679f;
//   font-size: 18px;
//   font-weight: bold;
//   padding: 14px 0;
// }

// .card-title--right {
//   font-size: 14px;

//   text-align: right;
//   padding: 18px 0;
//   cursor: pointer;
// }

.card-image {
  display: block;
  width: 100%;
  height: 324px;
  // background-color: skyblue;
}

.card-content {
  font-size: 15px;
  padding: 10px 0;
  min-height: 42px;
  cursor: pointer;
  &:hover {
    color: #15458b;
    text-decoration: underline;
  }
}

.card-subtitle {
  font-size: 13px;
}
</style>
